import Carousel from '../components/Carousel'
import Contact from '../components/Contact'
import Feedbacks from '../components/Feedbacks'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import IdeaSectionAbout from '../section/IdeaSectionAbout'
import SearchEngineHero from '../section/SearchEngineHero'
import PartnersLogos from '../components/PartnersLogos'
import React from 'react'
import { Helmet } from 'react-helmet';
import IdeaSeoSect from '../section/IdeaSeoSect'

function SearchEngine() {
  return (
    <div className="relative z-0 bg-[#060816]">
      <Helmet>
<title>Search Engine - The Designsinc.</title>
</Helmet>
    <div>
      <Navbar />
      <div>
        {/** About Section */}
       <SearchEngineHero />
        {/**Slider logos company */}
        <PartnersLogos />

        {/**idea section and btns */}
        <IdeaSeoSect />

        {/** Testimonials */}
        <div className="">
        <Feedbacks  />
        </div>
        {/** contact section */}
        <div className='relative z-0'>
      <Contact />
     
    </div>
      </div>
    </div>

    <Footer />
  </div>
  )
}

export default SearchEngine